import { inject } from '@angular/core';
import { FiltersValues } from '../../../models';
import { Observable } from 'rxjs';
import { FiltersStorage } from '@find-games/infra';

export class GetFiltersQueryHandler {
  private readonly filtersStorage: FiltersStorage = inject(FiltersStorage);

  filters(): Observable<FiltersValues> {
    return this.filtersStorage.filters$;
  }
}
